import React, { useEffect, useRef, useState } from 'react'
import { SBAComboBox, SBAMultiSelect, SBAMultiSelectCheck } from '../../../../UiComponents/SBADropDown'
import { SBDatePicker } from '../../../../UiComponents/SBDatePicker'
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from '../../../../utils/sbaAxios';
import { 
  getAllFamilies,
  getBillingReview } from '../../../../../config/apiConfig';
import moment from "moment";

export const Review = () => {
  const [familyList,setFamilyList]=useState([]);
  const [reportDate, setReportDate] = useState(new Date());
  const [billingRowData, setBillingRowData] = useState([]);
  const [invoiceRowData, setInvoiceRowData] = useState([]);
  const [selectedFamily,setSelectedFamily]=useState([]);
  const [selectedInvoice,setSelectedInvoice]=useState({InvoiceId:1,InvoiceText:"All"});
  const [selectedCalculation,setSelectedCalculation]=useState({CalId:1,CalText:"All"});
  const invoiceStatus=[{InvoiceId:1,InvoiceText:"All"},
  {InvoiceId:2,InvoiceText:"Generated"},
  {InvoiceId:3,InvoiceText:"Approved"}];

  const calculationStatus=[
  {CalId:1,CalText:"All"},
  {CalId:2,CalText:"Pending"},
  {CalId:3,CalText:"Reviewed"},
  {CalId:4,CalText:"Approved"}
  ];

  const getFamilyData = (searchText) => {
    sbaAxios({ url: `${getAllFamilies}` }).then(res => {
      setFamilyList(res)
    }).catch(()=>{
      setFamilyList([]);
    });
  };

  const getBillingData = async() => {
    try {
      const list = await sbaAxios({
        url: getBillingReview,
        params: {
          ReportDate:reportDate.toISOString()
        }
      });
      console.log(list);
    } catch (error) {
      console.log(error);
    }
  };

  const isInitialLoad = useRef(true);
  useEffect(() => {
    if (isInitialLoad.current) {
      getFamilyData();
      getBillingData();
      isInitialLoad.current = false;
    }
  }, []);
  
  return (
    <>
      <div className='row'>
        <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Family</label>
            <div>
              <SBAMultiSelectCheck  
              data={familyList} 
              textField={"FamilyName"} 
              tags={
                selectedFamily?.length > 0
                    ? [{ text: `${selectedFamily.length} items selected`, data: [...selectedFamily] }]
                    : []
              }
              value={selectedFamily}
              onChange={(e)=>{setSelectedFamily(val=>([...e.value]))}}
              dataItemKey={"FamilyId"}/>
            </div>
          </div>

        </div>
        <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Report Date</label>
            <div>
              <SBDatePicker
                value={moment(reportDate)}
                onChange={(newDate)=>{setReportDate(newDate)}}
              />
            </div>
          </div>
        </div>
        <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Calculation Status</label>
            <div>
              <SBAComboBox 
              data={calculationStatus}
              textField={"CalText"}
              valueField={"CalId"}
              value={selectedCalculation}
               onChange={(e)=>{if(e.value){setSelectedCalculation(e.value)}}}
              />
            </div>
          </div>
        </div>
        <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Invoice Status</label>
            <div>
              <SBAComboBox 
               textField={"InvoiceText"}
               valueField={"InvoiceId"}
               data={invoiceStatus}
               value={selectedInvoice}
               onChange={(e)=>{if(e.value){setSelectedInvoice(e.value)}}}
              />
            </div>
          </div>
        </div>
        <div className='col-12 col-md-4 d-flex row-items gap-2 justify-content-between'>
          <button className='p-sm-btn' onClick={getBillingData}>Go</button>
          <div className='d-flex flex-column '>
            <span className='d-inline block'></span>
            <span className='d-inline block'></span>
          </div>
        
        </div>
      </div>
      <div className='row'>
        <BillingSection />
      </div>
      <div className='row'>
        <InvoiceSection/>
      </div>
    </>
  )
};
const BillingSection = ({}) => {
  const columnDefs = [
    { headerName: "Family Name", field: "FamilyName"  },
    { headerName: "Billing Name", field: "BillingName" },
    { headerName: "Gross", field: "Gross" },
    { headerName: "Credits", field: "Credits" },
    { headerName: "PPLI", field: "PPLI" },
    { headerName: "Net", field: "Net" },
    { headerName: "Status", field: "Status" },
    { headerName: "Status by", field: "StatusBy" },
    { headerName: "Status Date", field: "StatusDate" },
    { headerName: "Action", field: "Action" },
    { headerName: "Comment", field: "Comment" },
  ];
  const defaultColumnDef={flex:1,autoHeaderHeight: true,wrapHeaderText: true,resizable: true,};
  return <><div className='d-flex  my-3'>
    <label className="mb-1 label">Billing</label>
    <div className='ms-auto'>
    <button className='p-sm-btn mx-2'>Save</button>
    <button className='p-sm-btn mx-2'>Export</button>
    </div>

  </div>
    <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
      <AgGridReact columnDefs={columnDefs} rowData={[]} defaultColDef={defaultColumnDef}></AgGridReact>
    </div>
  </>
};
const InvoiceSection = () => {
  const columnDefs = [
    { headerName: "Family Name", field: "FamilyName"  },
    { headerName: "Billing Name", field: "BillingName" },
    { headerName: "Gross", field: "Gross" },
    { headerName: "Credits", field: "Credits" },
    { headerName: "PPLI", field: "PPLI" },
    { headerName: "Net", field: "Net" },
    { headerName: "Adjustments", field: "Adjustments" },
    { headerName: "Total Net", field: "TotalNet" },
    { headerName: "Status", field: "Status" },
    { headerName: "Status by", field: "StatusBy" },
    { headerName: "Status Date", field: "StatusDate" },
    { headerName: "Action", field: "Action" },
    { headerName: "Comment", field: "Comment" },
  ];
  const defaultColumnDef={flex:1,autoHeaderHeight: true,wrapHeaderText: true,resizable: true,};
  return <><div className='d-flex  my-3'>
    <label className="mb-1 label">Invoice</label>
    <div className='ms-auto'>
    <button className='p-sm-btn mx-2 '>Save</button>
    <button className='p-sm-btn  mx-2'>Export</button>
    </div>
    
  </div>
    <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
      <AgGridReact columnDefs={columnDefs} rowData={[]} defaultColDef={defaultColumnDef}></AgGridReact>
    </div>
  </>
};
